import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import { Button } from '@mui/material/'
import ClearIcon from '@mui/icons-material/Clear'
import type { Theme, ButtonProps } from '@mui/material'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: 50,
    minWidth: 50,
    padding: theme.spacing(0.5, 2, 0.25),
  },
  buttonInner: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 50,
    height: 'auto',
    textAlign: 'center',
  },
  icon: {
    display: 'block',
    padding: 0,
  },
  text: {
    display: 'block',
    fontSize: theme.spacing(1.5),
  },
}))

const DeleteButton: React.FC<ButtonProps> = ({ ...props }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  return (
    <Button {...props} className={classes.root}>
      <div className={classes.buttonInner}>
        <ClearIcon className={classes.icon} />
        <span className={classes.text}>{t('削除')}</span>
      </div>
    </Button>
  )
}

export default DeleteButton
